export default __webpack_public_path__ + "static/media/thumbnail.c05dd665.png";